module.exports = __webpack_public_path__ + "assets/images/balendar-on.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/balendar-on.png
// module id = 1491
// module chunks = 1